import { FEED_ACTION_BAR_SX, FEED_VIDEO_MEDIA_SX } from '../../components/FeedCards/feedCardTheme'

/** Shared layout tokens for Slop feed surfaces (Discover, library, detail). */
export const SLOP_FEED_MOBILE_MQ = '(max-width: 575px)'
export const SLOP_FEED_NARROW_MQ = '(max-width: 390px)'

/** Re-export for detail surfaces (modal + full page). */
export { FEED_ACTION_BAR_SX }

/** Native slop video: 9:16 on narrow viewports, 16:9 from sm up. */
export const slopDetailNativeVideoSx = {
  width: '100%',
  display: 'block',
  background: '#000',
  objectFit: 'cover' as const,
  ...FEED_VIDEO_MEDIA_SX
} as const

/** Edge-to-edge media inside padded shells (modal body, post page). */
export const slopDetailVideoBleedSx = {
  [SLOP_FEED_MOBILE_MQ]: {
    width: '100vw',
    maxWidth: '100vw',
    marginLeft: '50%',
    transform: 'translateX(-50%)',
    borderRadius: 0
  }
} as const

export const slopDetailEmbedSx = {
  width: '100%',
  paddingBottom: { base: 'min(177.78%, 85dvh)', sm: '56.25%' },
  position: 'relative' as const,
  background: 'var(--gs-surface1)',
  ...slopDetailVideoBleedSx
} as const

/** 44px touch targets in thumb zone (mobile action bars). */
export const slopThumbActionIconSx = {
  [SLOP_FEED_MOBILE_MQ]: { width: 44, height: 44 }
} as const

export const slopPostDetailModalStyles = {
  content: {
    [SLOP_FEED_MOBILE_MQ]: {
      margin: 0,
      borderRadius: 0,
      maxHeight: '100dvh',
      overflow: 'hidden'
    }
  },
  body: {
    [SLOP_FEED_MOBILE_MQ]: { padding: 0 }
  },
  header: {
    [SLOP_FEED_MOBILE_MQ]: {
      paddingLeft: 12,
      paddingRight: 12
    }
  }
} as const

export const slopDiscoverShellSx = {
  width: '100%',
  maxWidth: { base: '100%', sm: 720 },
  margin: '0 auto',
  paddingLeft: { base: 0, sm: 0 },
  paddingRight: { base: 0, sm: 0 }
} as const

export const slopFeedPageShellSx = {
  maxWidth: 1400,
  margin: '0 auto',
  padding: '24px',
  [SLOP_FEED_MOBILE_MQ]: {
    padding: '8px 0 16px',
    maxWidth: '100%'
  }
} as const

export const slopPostPageShellSx = {
  maxWidth: 900,
  margin: '0 auto',
  padding: '16px 24px 48px',
  [SLOP_FEED_MOBILE_MQ]: {
    maxWidth: '100%',
    padding: '8px 0 max(16px, env(safe-area-inset-bottom))'
  }
} as const

export const slopShootDetailShellSx = {
  maxWidth: 520,
  margin: '0 auto',
  padding: '16px',
  [SLOP_FEED_MOBILE_MQ]: {
    maxWidth: '100%',
    padding: '0 0 max(12px, env(safe-area-inset-bottom))'
  }
} as const
